export const CHECK_COPY: Record<string, string> = {
  rows_resolved:
    'Review status is green for all companies (fully reviewed, no review needed, and no deferred price still outstanding)',
  carry_forward: 'Marks match the previous day\'s saved CSV except where this day called for a new price',
  mark_present: 'A valid mark is present for every company',
};
